import {
  DateRange,
  RANGE_PRESETS,
  presetRange,
  rangeDays,
  rangeLabel,
  toDayString,
} from "../lib/dateRange";

/**
 * Date-range control for the dashboard. Preset buttons snap the range; the two
 * date inputs override it and flip the range to "custom".
 */
export function DateRangeFilter({
  value,
  onChange,
}: {
  value: DateRange;
  onChange: (next: DateRange) => void;
}) {
  const today = toDayString(new Date());
  const days = rangeDays(value);

  const setStart = (startDate: string) => {
    // Keep the range ordered — dragging start past end pushes end along.
    const endDate = startDate && value.endDate && startDate > value.endDate ? startDate : value.endDate;
    onChange({ startDate, endDate, preset: "custom" });
  };

  const setEnd = (endDate: string) => {
    const startDate =
      endDate && value.startDate && endDate < value.startDate ? endDate : value.startDate;
    onChange({ startDate, endDate, preset: "custom" });
  };

  return (
    <div className="drf">
      <div className="drf-summary">
        <i className="ti ti-calendar-event" aria-hidden="true" />
        <span className="drf-label">{rangeLabel(value)}</span>
        {days != null && (
          <span className="drf-days">
            {days} day{days === 1 ? "" : "s"}
          </span>
        )}
      </div>

      <div className="drf-controls">
        <div className="drf-presets" role="group" aria-label="Quick date ranges">
          {RANGE_PRESETS.map((p) => (
            <button
              key={p.key}
              type="button"
              className={"drf-preset" + (value.preset === p.key ? " on" : "")}
              aria-pressed={value.preset === p.key}
              onClick={() => onChange(presetRange(p.key))}
            >
              {p.label}
            </button>
          ))}
        </div>

        <label className="ss-filter">
          <span>From</span>
          <input
            type="date"
            value={value.startDate}
            max={value.endDate || today}
            onChange={(e) => setStart(e.target.value)}
          />
        </label>
        <label className="ss-filter">
          <span>To</span>
          <input
            type="date"
            value={value.endDate}
            min={value.startDate || undefined}
            max={today}
            onChange={(e) => setEnd(e.target.value)}
          />
        </label>
      </div>
    </div>
  );
}
